export const LogoutPage = () => {
  return <div>Logout</div>;
};
